import React, { useState, useCallback, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import LoadingScreen from './LoadingScreen'
import SpotlightIntro from './SpotlightIntro'

const IntroManager = ({ children }) => {
  const [phase, setPhase] = useState(() => (typeof window === 'undefined' ? 'done' : 'loading'))

  const handleLoadingComplete = useCallback(() => {
    // Always show spotlight after loading for visibility/testing.
    setPhase('spotlight')
  }, [])

  const handleSpotlightComplete = useCallback(() => {
    // Move to done; do not persist so spotlight can run on next load during testing.
    setPhase('done')
  }, [])

  useEffect(() => {
    if (phase === 'done') {
      const timer = setTimeout(() => {
        document.body.style.overflow = ''

        // Ensure any scroll-reveal elements are visible in case the observer
        // didn't run while the intro overlay was active.
        try {
          document.querySelectorAll('.reveal:not(.reveal-visible)').forEach((el) => {
            el.classList.add('reveal-visible')
          })
        } catch (e) {}
      }, 100)

      return () => clearTimeout(timer)
    } else {
      document.body.style.overflow = 'hidden'
    }
  }, [phase])

  return (
    <>
      <AnimatePresence mode="wait">
        {phase === 'loading' && (
          <LoadingScreen key="loading" onComplete={handleLoadingComplete} />
        )}
        {phase === 'spotlight' && (
          <SpotlightIntro key="spotlight" onComplete={handleSpotlightComplete} />
        )}
      </AnimatePresence>

      <div
        style={{
          opacity: phase === 'done' ? 1 : 0,
          transition: 'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        {children}
      </div>
    </>
  )
}

export default IntroManager
